import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex" };
const _hoisted_2 = { class: "flex items-center w-full mx-4 mt-2 mb-8" };
const _hoisted_3 = { class: "flex w-full mx-4 mt-2 mb-8 gap-4 justify-end" };
const _hoisted_4 = { class: "relative flex items-center w-[350px]" };
const _hoisted_5 = { class: "flex justify-around w-[200px]" };
import { Grid01Icon, ListIcon, SearchLgIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIButton, UIButtonGroup, UIInput, UISelect, UISpace, UITextSmRegular, UITextXsRegular, } from '@gohighlevel/ghl-ui';
import { GOOGLE_DRIVE } from 'src/util/const_helper';
import { computed, h, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import DoubleTickIcon from '../assets/img/double-tick-blue.svg';
import GoogleDriveIcon from '../assets/img/google-drive.svg';
import MyMediaIcon from '../assets/img/image-04.svg';
import PixabayIcon from '../assets/img/pixabay.svg';
import BackgroundIcon from '../assets/img/rectangle.svg';
import UnsplashIcon from '../assets/img/scale-03.svg';
import { useStore } from '../store';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MediaSearchBar',
    emits: ["close", "sort", "search", "setCategory", "setMediaLayout"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const { t } = useI18n();
        const state = useStore();
        const search = ref('');
        const sectionView = ref('grid');
        function setCategory(item) {
            category.value = item;
            emit('setCategory', item);
        }
        const selfHosted = computed(() => {
            return state.selfHosted;
        });
        const selectLayput = (type) => {
            sectionView.value = type;
        };
        const categories = computed(() => {
            var _a;
            const defaultItems = [
                { label: t('common.all'), value: 'all', icon: DoubleTickIcon },
                { label: t('common.myMedia'), value: 'my_media', icon: MyMediaIcon },
                {
                    label: t('common.backgrounds'),
                    value: 'backgrounds',
                    icon: BackgroundIcon,
                },
                { label: 'Unsplash', value: 'unsplash', icon: UnsplashIcon },
                { label: 'Pixabay', value: 'pixabay', icon: PixabayIcon },
            ];
            if (state.googleConnectionInfo) {
                (_a = state.googleConnectionInfo) === null || _a === void 0 ? void 0 : _a.map(connection => {
                    if (connection.userId === state.userId) {
                        defaultItems.push({
                            label: 'Google Drive',
                            value: `${GOOGLE_DRIVE}_${connection.id}`,
                            icon: GoogleDriveIcon,
                            subLabel: connection.email,
                        });
                    }
                });
            }
            return !selfHosted.value
                ? defaultItems
                : [{ label: t('common.myMedia'), value: 'my_media', icon: MyMediaIcon }];
        });
        // Disable sorting when selected category is other than my_media or all
        const disabledSortOption = computed(() => {
            return (state.activeCategory !== 'my_media' &&
                state.activeCategory !== 'all' &&
                !state.activeCategory.includes(GOOGLE_DRIVE));
        });
        const sortingOptions = [
            {
                label: 'Name: A to Z',
                value: 'name-a-to-z',
                sortBy: false,
            },
            {
                label: 'Name: Z to A',
                value: 'name-z-to-a',
                sortBy: true,
            },
            {
                label: 'Size: Smallest First ',
                value: 'size-small',
                sortBy: false,
            },
            {
                label: 'Size: Largest First ',
                value: 'size-large',
                sortBy: true,
            },
            {
                label: 'Modified: Newest First',
                value: 'updatedAt-newest',
                sortBy: true,
            },
            {
                label: 'Modified: Oldest First',
                value: 'updatedAt-oldest',
                sortBy: false,
            },
        ];
        const googleSortingOptions = [
            {
                label: 'Name: A to Z',
                value: 'name-a-to-z',
                sortBy: false,
            },
            {
                label: 'Name: Z to A',
                value: 'name-z-to-a',
                sortBy: true,
            },
            {
                label: 'Modified: Newest First',
                value: 'updatedAt-newest',
                sortBy: true,
            },
            {
                label: 'Modified: Oldest First',
                value: 'updatedAt-oldest',
                sortBy: false,
            },
        ];
        const category = ref('my_media');
        const setSort = ref('updatedAt-newest');
        const orderBy = ref(true);
        const selectOptionsComponent = (option) => {
            const label = [
                h(UISpace, {
                    class: 'py-2 w-max cursor-pointer rounded',
                    align: 'center',
                    wrap: false,
                }, () => [
                    h('img', { src: option.icon }),
                    h(UITextSmRegular, { class: 'text-gray-900 w-44' }, () => [
                        h(UITextSmRegular, { class: 'text-gray-900 p-0' }, () => option.label),
                        h(UITextXsRegular, { class: 'text-gray-900 p-0 truncate w-40' }, () => option.subLabel),
                    ]),
                ]),
            ];
            return label;
        };
        watch(search, () => {
            emit('search', search.value);
        });
        watch(sectionView, () => {
            emit('setMediaLayout', sectionView.value);
        });
        watch([setSort, orderBy], () => {
            const found = sortingOptions.find(i => i.value === setSort.value);
            emit('sort', {
                sortBy: { name: found.label, value: found.value.split('-')[0] },
                sortOrder: found === null || found === void 0 ? void 0 : found.sortBy,
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, [
                        _createVNode(_unref(UISelect), {
                            id: "media-storage-category-menu",
                            class: "w-44 px-1 text-sm text-gray-600 border-gray-300 rounded-md lg:w-100",
                            options: categories.value,
                            value: _unref(state).activeCategory,
                            filterable: "",
                            "onUpdate:value": setCategory,
                            renderLabel: (option) => selectOptionsComponent(option)
                        }, null, 8 /* PROPS */, ["options", "value", "renderLabel"])
                    ])
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(UIInput), {
                            id: "media-search-input",
                            modelValue: search.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((search).value = $event)),
                            clearable: "",
                            placeholder: "Search media or explore stock images"
                        }, {
                            prefix: _withCtx(() => [
                                _createVNode(_unref(SearchLgIcon), { class: "w-4 h-4" })
                            ]),
                            suffix: _withCtx(() => []),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_unref(UISelect), {
                            id: "sortFilter",
                            options: _unref(state).activeCategory.includes(_unref(GOOGLE_DRIVE))
                                ? googleSortingOptions
                                : sortingOptions,
                            value: setSort.value,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event) => ((setSort).value = $event)),
                            disabled: disabledSortOption.value
                        }, null, 8 /* PROPS */, ["options", "value", "disabled"])
                    ]),
                    _createElementVNode("div", null, [
                        _createVNode(_unref(UIButtonGroup), { id: "media-grid-list-switch" }, {
                            default: _withCtx(() => [
                                _createVNode(_unref(UIButton), {
                                    onClick: _cache[2] || (_cache[2] = ($event) => (selectLayput('grid'))),
                                    ghost: "",
                                    id: "btn-1",
                                    active: sectionView.value === 'grid'
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(Grid01Icon), { class: "w-4 h-4" })
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["active"]),
                                _createVNode(_unref(UIButton), {
                                    onClick: _cache[3] || (_cache[3] = ($event) => (selectLayput('list'))),
                                    ghost: "",
                                    id: "btn-2",
                                    active: sectionView.value === 'list'
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(ListIcon), { class: "w-4 h-4" })
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["active"])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ])
            ]));
        };
    }
});
